import { z } from "zod";
import { PreferredContactMethodSchema } from "@remi/enums/preferred-contact-method";

import { FileTypeSchema } from "./file";

/**
 * Use this if you need to loop through all the options
 */
export const ScopeOfWorkTypeValues = [
  "ROOFING",
  "R_AND_R",
  "ADDITIONAL_WORK",
  "BID",
  "BACKFILL",
  "ASSESSMENT",
  "SITE_VISIT",
  "SIDING",
  "GUTTERS",
  "CORRECTIONS",
  "ESTIMATE_ONLY",
  "QA",
] as const;
/**
 * Use this if you need to zod parse it
 */
export const ScopeOfWorkTypeSchema = z.enum(ScopeOfWorkTypeValues);
/**
 * Use this if you need to use the literal value
 */
export const ScopeOfWorkType = ScopeOfWorkTypeSchema.enum;
/**
 * Use this if you need to use the type
 */
export type ScopeOfWorkType = z.infer<typeof ScopeOfWorkTypeSchema>;
/**
 * Use this if you need to display a human-readable name
 */
export const ScopeOfWorkTypeDisplayNames: Record<ScopeOfWorkType, string> = {
  ASSESSMENT: "Assessment",
  ROOFING: "Roofing",
  ADDITIONAL_WORK: "Additional Work",
  R_AND_R: "R&R",
  BID: "Bid",
  BACKFILL: "Backfill",
  SITE_VISIT: "Site Visit",
  SIDING: "Siding",
  GUTTERS: "Gutters",
  CORRECTIONS: "Corrections",
  ESTIMATE_ONLY: "Estimate Only",
  QA: "QA",
} as const;

export const SowConfirmationInputSchema = z.object({
  bidId: z.number(),
  homeownerId: z.string(),
  propertyAddressId: z.string(),
  name: z.string(),
  phone: z.string(),
  email: z.string(),
  addressStreet: z.string(),
  city: z.string(),
  stateCode: z.string(),
  zip: z.string(),
  hoaApprovalNeeded: z.boolean().nullable(),
  allowUnattendedSiteVisit: z.boolean().nullish(),
  preferredContactMethod: PreferredContactMethodSchema.nullable(),
  additionalInformation: z.string().optional(),
  signature: z
    .object({
      name: z.string(),
      type: FileTypeSchema,
      id: z.string(),
    })
    .optional(),
});
